import { getFrequencyMap } from './getFrequencyMap';
export const getDuplicatedValues = (values) => {
    const countMap = getFrequencyMap(values);
    const duplicatedValues = [...countMap.entries()].flatMap(entry => entry[1] > 1 ? [entry[0]] : []);
    return duplicatedValues;
};
//# sourceMappingURL=getDuplicatedValues.js.map